<template>
    <div class="search" v-if="!navbar">
        <form id="FormSearch" @submit="captureAnalytics" action="buscar">
            <el-autocomplete v-model="query" :name="name" :autofocus="false" :trigger-on-focus="false"
                :fetch-suggestions="querySearchAsync" :placeholder="placeh" @select="handleSelect">
                <button id="btn_search" v-bind:class="{ 'is-disabled': !query }" class="el-button el-button--default top"
                    :disabled="!query" style="background-color: #0F69B4;" slot="append" aria-label="Botón buscar"
                    type="submit">
                    <span class="hidden-xs"><strong>{{ title }}</strong></span>
                    <i class="fas fa-search visible-xs"></i>
                </button>
            </el-autocomplete>

        </form>
    </div>

    <div v-else style="margin-top:27px">
        <form id="" @submit="captureAnalytics" action="buscar">
            <el-autocomplete style="width: 282px; height: 36px;" maxlength="140" v-model="query" :name="name"
                :autofocus="false" :trigger-on-focus="false" :fetch-suggestions="querySearchAsync" :placeholder="placeh"
                @select="handleSelect">
                <el-button id="btn_search" style="width: 39px; height: 36px;background-color: #0F69B4;" slot="append"
                    aria-label="Botón buscar" class="el-button el-button--default top is-disabled" :disabled="!query"
                    native-type="submit">
                </el-button>
            </el-autocomplete>
        </form>
    </div>
</template>
<style lang="scss" scoped>
#btn_search:hover {
    box-shadow: 0px 0px 6px 2px #35ac19;
    background-color: #eaf2f9 !important;
}

#btn_search:hover.is-disabled {
    box-shadow: none;
    background-color: transparent !important;
}
</style>
<script>
import ElAutocomplete from 'element-ui/lib/autocomplete';
import ElButton from 'element-ui/lib/button';

export default {
    data: function () {
        return {
            query: this.value,
            placeh: this.place,
        }
    },
    props: ['name', 'value', 'place', 'title', 'navbar'],
    components: {
        ElAutocomplete,
        ElButton
    },
    methods: {
        querySearchAsync(queryString, cb) {
            let self = this;

            if (this.query.length > 140) {
                this.query = this.query.slice(0, 140);
            }

            if (self.query.length > 2 && self.query.length < 15) {
                let token = $('meta[name="cha-token"]').attr('content');
                axios.get('api/suggest?token=' + token + '&query=' + self.query)
                    .then(function (response) {
                        let results = response.data.map(function (d) {
                            return {
                                value: d.query
                            };
                        });
                        cb(results);
                    })
            }
        },
        // querySearchAsync: _.debounce(function(queryString, cb){
        //     var self = this;

        //     if (this.query.length > 140){

        //          this.query=   this.query.slice(0,140);


        //     }

        // if (self.query.length > 2 && self.query.length < 15){

        // var token = $('meta[name="cha-token"]').attr('content');

        //     axios.get('api/suggest?token='+token+'&query=' + self.query)
        //         .then(function(response) {
        //             var results = response.data.map(function (d) {
        //                 return {
        //                     value: d.query
        //                 };
        //             });

        //             cb(results);
        //         })
        // }
        // },2000,{leading: true}),
        handleSelect: function (item) {
            var self = this;

            Vue.nextTick(function () {
                self.$el.querySelector('button').click();
            });
        },
        captureAnalytics: function () {
            if (this.query.length > 140) {

                this.query = this.query.slice(0, 140);


            }
            window.ga('send', 'event', 'Acciones Portada', 'Búsqueda principal', this.query);
            return true;
        }

    }
}
</script>

